const Backbone = require('lib/backbone')
const Marionette = require('lib/marionette')
const _ = require('lib/underscore')
const $ = require('lib/jquery')
const log = require('log').create('css'); // eslint-disable-line


const CssView = Marionette.View.extend({

    displayName: 'CssView',
    tagName: 'style',
    attributes() {
        return {
            'type': 'text/css',
            'id': this.cid,
            'data-related-view': this.options.label || this.cid,
        }
    },
    templateContext() {
        const templateContext = _.result(this.options, 'helpers') || {}
        _.each(this.options.data, (item, key) => {
            if (item instanceof Backbone.Model) {
                templateContext[key] = item.serialize()
            } else {
                templateContext[key] = item
            }
        })
        return templateContext
    },
    initialize() {

    },
    onBeforeRender() {
        // log.time('CSS render');
    },
    onRender() {
        // log.timeEnd('CSS render');
    },
    onEvent(name, child) {

    },
})

const CssBehavior = Marionette.Behavior.extend({

    initialize(options) {
        if (! options) return log.error('CSS requires options')
        if (! options.template) return log.error('CSS requires a template')
        // log(options.label, 'initialize')

        this.data = this.options.templateData

        // add user.css as a separate item to data object
        if (this.data && this.data.user && this.data.user.css) {
            this.data.css = this.data.user.css
        }

        // ensure that options.templateContext is always called with the parent view as context
        if (_.isFunction(this.options.templateContext)) {
            this.options.templateContext = _.bind(this.options.templateContext, this.view)
        }

        this.setupListeners()

        this.createCssView()

        this.view.css = this
    },

    setupListeners() {
        if (! this.data) return

        const template_keys = this.parseTemplateKeys()

        // split data keys into object_name and property pairs
        const items = _.map(template_keys, (key) => {
            const parts = key.split('.')
            const object_name = parts.shift()
            const property = parts.join('.')

            return {
                object_name,
                property,
            }
        })
        /* items is now an array of dicts:
        [
            { object_name: 'user', property: 'layout.foo.url' },
            { object_name: 'css', property: 'layout.bar.baz' },
            { object_name: 'g', property: 'STATIC_HOSTNAME' },
            { ... }
        ]
        */

        // loop through items and listen to any models
        _.each(items, (item) => {
            const object = this.data[item.object_name]
            if (object instanceof Backbone.Model) {
                this.listenTo(object, `change:${item.property}`, this.onChange)
            } else {
                // log(item, object)
            }
        })

    },

    parseTemplateKeys() {
        // parse template for data variables

        const regex = /data\.[a-z0-9_\-.]+/gi
        let matches = this.options.template.match(regex)

        matches = _.map(matches, (item) => {
            return item.replace(/^data\./, '')
        })

        return _.unique(matches)
    },

    onChange() {
        this.createCssView()
    },

    render() {
        this.createCssView()
    },

    createCssView() {
        // log('render css', this.options.label)

        const css_view = new CssView({
            label: this.options.label,
            template: _.template(this.options.template),
            helpers: this.options.templateContext,
            data: this.options.templateData,
        })

        $.head.append(css_view.el)
        css_view.render()

        // destroy the old css view
        this.destroyCssView()

        // cache reference to the new css view
        this.css_view = css_view

    },

    destroyCssView() {
        if (this.css_view) this.css_view.destroy()
    },

    onBeforeDestroy() {
        // log('destroy')
        this.destroyCssView()
    },

})

module.exports = CssBehavior
